<template>
    <div class="update-plan">
        <cart-nav :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="cartIndex"></cart-nav>
        <div :class="['content', {'reo-processing': processing}]" v-if="hasSub">
            <template v-if="config.platform === 'web'">
                <h1>{{ title }}</h1>
                <p>{{ $t('dashboard.items.switch_note') }}</p>
            </template>
            <div class="content-wrap js-content-wrap">
                <h3>{{ $t('update_plan.sub_title') }}</h3>
                <plan-message :list="message" class="plan-message"></plan-message>
            </div>
            <div class="plans">
                <h3>{{ $t('subscribe.planChooseTitle') }}</h3>
                <plan-subscribe-section
                    @subscribe="selectProduct"
                    :productsArgs="{
                        legacy: legacy,
                        page: 'update-plan'
                    }"
                    :sub="sub"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import planMessage from '@/components/planMessage.vue';
import { previewSubscriptions, getPlanById } from '@/api/cart';
import { freePlanRenewable } from '@/api/plan';
import { unfoldError } from '@/common/js/notice';
import { config } from 'CONFIG';
import { currStage, payment as paymentStatus, plan as planStatus } from '@/config/status';
import { getDeviceTotal } from '@/api/cloud';
import { getSubscriptionById, getSubscriptions } from '@/api/subscriptions';
import cartNav from '@/components/cartNav.vue';
import reolinkGa from '@/common/js/gtagPageview';
import nprogress from 'nprogress';
import { isInVisibleArea, unitTransfer } from '@/common/js/utils';
import { AxiosError } from 'axios';
import { IPlanMessage } from '@reolink-cloud/interface';
import { ESubscribeMode } from '@/interface';
import PlanSubscribeSection from '@/components/PlanSubscribeSection/index.vue';
import { ISubscribeArgsWithDeviceInfo } from '@/components/PlanSubscribeSection/lib/types';
import { handleGetUserDataError } from '@/utils/business';

export default Vue.extend({

    components: {

        planMessage,
        cartNav,
        PlanSubscribeSection

    },

    data () {

        return {
            prev_sub_id: this.$route.query.ps_id as string | null,
            planList: [] as any[],
            refund: [] as any[],
            planId: '',
            config,
            cartIndex: 0,
            switchable: false,
            hasSub: false,
            sub: {} as Record<string, any>,
            subs: {} as Record<string, any>,
            disabledPlan: [] as any[],
            processing: false,
            activeItem: 100,
            currentVideoQuantity: 0,
            planTitle: '',
            selectedProduct: [] as any[],
            error: false,
            currentDeviceGroup: '',
            showDevices: false,
            selectLimit: 0,
            deviceData: [] as any[],
            dialogStack: [] as any[],
            selectedDevices: [] as any[],
            selectedDevicesURL: '',
            planNoticeText: '',
            updateDisabled: false,
            unpayOrders: [] as any[],
            orders: [] as any[],
            initialized: false,
            gtagData: {} as Record<string, any>,
            isNewCustomer: true,
            basicSerial: {} as Record<string, any>,
            basicPlanItem: {} as Record<string, any>,
            basicSelected: false,
            prevSelectedPlan: {} as Record<string, any>,
            switchingLegacy: true,
            productsInit: false,
            isExpand: false,
            bottomButtonShow: false,
            showAiInfo: false,
            legacy: ''
        };

    },
    async created () {

        await this.init();

        nprogress.done();

    },
    mounted() {

        window.addEventListener( 'scroll', this.calcPlanIsInWindow );

    },
    methods: {

        async selectProduct ( args: ISubscribeArgsWithDeviceInfo ): Promise<void> {

            const { plan, series } = args;
            this.updateDisabled = false;
            this.planId = plan.id;
            this.planTitle = series.i18n.name;
            let sub = this.sub;
            let price = Number( plan.pricing.salePrice );
            /**
             * 收费套餐切换至免费套餐时预览退款金额
             *
             * 否则不显示退款金额
             */
            if ( sub && sub.status === 'active' && Number( sub.plan.cycle.salePrice ) > 0 && price === 0 ) {

                this.processing = true;
                let previewData: Record<string, any > = {};
                previewData.productId = plan.id;
                previewData.qty = 1;
                previewData.context = {
                    action: 'switch',
                    associateDevices: [],
                    lang: this.$store.getters.lang,
                    subscription: this.prev_sub_id

                };
                try {

                    let sub = await previewSubscriptions( previewData );
                    if ( sub.refund ) {

                        this.refund = sub.refund;

                    } else {

                        this.refund = [];

                    }

                } catch ( err ) {

                    this.updateDisabled = true;
                    this.processing = false;
                    const symbol = ( err as AxiosError ).response?.data.error.symbol;

                    let key = 'errors.error_unknown';

                    if ( symbol === 'violate_subscribe_restriction' ) {

                        let reason = ( err as AxiosError ).response?.data.error.metadata.reason;
                        if ( reason === 'onlyOneFreePlan' ) {

                            key = 'Only one free plan you can have';

                        }

                    }
                    console.error(( err as AxiosError ).response?.data.error.metadata.reason );
                    unfoldError( key, 5000 );

                }

                this.processing = false;

            } else if ( this.refund.length > 0 ) {

                this.refund = [];

            }
            let itemListName = `(cloud-Plan)storageRegion:${series.storageRegion};deviceGroup:${series.deviceGroup}`;
            let name = series.i18n.name;
            name += `(${plan.duration.amount}-${plan.duration.unit})`;
            name += `(${plan.style['cloud_storage.video_lifetime'] ?? 0}-days,${plan.style['cloud_storage.max_device_quantity'] ?? 0}-cams,${unitTransfer( plan.style['cloud_storage.space_capacity'] ?? 0 )}${unitTransfer( plan.style['cloud_storage.space_capacity'] ?? 0, 'unit' )})`;

            let eventData = {
                items: [{
                    item_id: plan.id,
                    item_name: `(cloud-Plan)${name}`,
                    item_category: 'cloud-Plan',
                    price: Number( plan.pricing.salePrice ),
                    item_list_name: itemListName,
                    item_variant: `mode:switch;currency:${plan.pricing.currency}`
                }]
            };
            this.gtagData = eventData;
            await this.goCheckout( args );

        },

        async init (): Promise<void> {

            this.initialized = false;

            try {

                let sub: Record<string, any> ;
                if ( this.prev_sub_id ) {

                    sub = await getSubscriptionById( this.prev_sub_id );
                    if ( sub.legacyTag ) {

                        this.switchingLegacy = true;

                    } else {

                        this.switchingLegacy = false;

                    }

                } else if ( config.platform === 'app' ) {

                    if ( this.subs.totalRows !== 0 ) {

                        let minIdSub = this.subs.items[0];
                        // 兼容旧版本app
                        for ( let sub of this.subs.items ) {

                            if ( sub.id < minIdSub.id ) {

                                minIdSub = sub;

                            }

                        }
                        this.prev_sub_id = minIdSub.id;
                        sub = minIdSub;

                    } else {

                        this.subs = await getSubscriptions( 'inactive' );
                        this.subs.items.sort(( a, b ) => b.expiredAt - a.expiredAt );
                        this.prev_sub_id = this.subs.items[0].id;
                        sub = this.subs.items[0];

                    }

                }

                if ( !sub! ) {

                    unfoldError( 'errors.no_plan_to_switch' );
                    return;

                }

                let planDetails = await getPlanById( sub.plan );
                planDetails.plan.title = planDetails.series.i18n.name;
                planDetails.plan.series = planDetails.series;

                this.$set( sub, 'plan', planDetails.plan );
                let portablePlanId = sub.plan.portablePlan;

                if ( sub.plan.status === planStatus.DISABLED ) {

                    if ( portablePlanId !== '0' ) {

                        let portablePlanDetails = await getPlanById( portablePlanId );

                        if ( portablePlanDetails.plan.status !== planStatus.ENABLED ||
                            !portablePlanDetails.plan.limitations.switchFromOther ) {

                            // 一个disable的套餐的portable套餐也被disable的时候，显示最新的套餐
                            this.legacy = '';

                        } else {

                            this.legacy = portablePlanDetails.series.legacyTag;

                        }

                    } else {

                        // portable套餐没填的时候为'0'，显示最新的套餐
                        this.legacy = '';

                    }

                } else {

                    this.legacy = sub.legacyTag;

                }

                this.sub = sub;

                // 统计当前事件
                reolinkGa.sendEvent( 'switch', sub.plan.id );

                /**
                 * 当nextSwitchableAt === 0 或者 当前时间小于nextSwitchableAt时间戳时，允许切换
                 */
                if ( sub.nextSwitchableAt === 0 || new Date().getTime() > sub.nextSwitchableAt ) {

                    this.switchable = true;

                } else {

                    // unfoldError( 'errors.frequent_switching' );
                    this.switchable = false;

                }

                let disabledPlan: string[] = [];
                /**
                 * 切换套餐页面：
                 *
                 * 当用户当前套餐为免费套餐时，
                 *
                 * 检查是否能够在此页面选择当前套餐进行续费
                 */

                if ( Number( sub.plan.cycle.salePrice ) === 0 && !freePlanRenewable( sub )) {

                    disabledPlan.push( sub.plan.id );

                }

                /**
                 * 默认选中套餐   query.p_id || 当前订阅的套餐id (无效套餐的关联套餐)
                 *
                 * 检查默认选中套餐是否可购买且有效
                 *
                 * 否则没有默认选中
                 */

                let planId = this.$route.query.p_id || sub.plan.id;
                if ( planId && !( disabledPlan.includes( planId ) && !sub.plan.portablePlan ) && !disabledPlan.includes( planId )) {

                    let breakable = false;
                    for ( let series of this.planList ) {

                        if ( breakable ) break;
                        for ( let plan of series.products ) {

                            if ( plan.id === planId || ( plan.id === portablePlanId && !disabledPlan.includes( portablePlanId ))) {

                                await this.selectProduct( plan );
                                breakable = true;
                                break;

                            }

                        }

                    }
                    if ( !breakable ) {

                        // 清除上一个机型组的默认选中
                        this.planId = '';

                    }

                }

                let unpayOrders: Array<{ id: string;title: string;createdAt: number; }> = [];
                for ( let order of this.orders ) {

                    if ( order.status.currStage === currStage.PAYMENT &&
                    order.status.paymentStatus === paymentStatus.CREATED &&
                    order.items[0].productType === 'storage_plan' &&
                    order.items[0].context.action !== 'renew' ) {

                        unpayOrders.push({ id: order.id, title: order.items[0].name, createdAt: order.createdAt });

                    }

                }

                if ( this.unpayOrders.length === 0 ) {

                    this.unpayOrders = unpayOrders;
                    this.$store.commit( 'UNPAYORDERS', JSON.parse( JSON.stringify( unpayOrders )));

                }

                this.disabledPlan = disabledPlan;
                this.hasSub = true;
                this.initialized = true;

            } catch ( err ) {

                /**
                 * 当前没有订阅，或者获取订阅信息失败的时候
                 *
                 * 不允许切换
                 */

                console.error( err );
                handleGetUserDataError( err, this.$router );

            }

        },

        async initDevices (): Promise<void> {

            if ( !this.subs ) {

                this.subs = await getSubscriptions( 'active' );

            }
            this.deviceData = await getDeviceTotal();

            for ( let device of this.deviceData ) {

                for ( let sub of this.subs.items ) {

                    if ( device.subscription === sub.id && device.status === 'associated' ) {

                        device.subName = sub.title;
                        if ( typeof sub.deviceList === 'undefined' ) {

                            sub.deviceList = [device.uid];

                        } else {

                            sub.deviceList.push( device.uid );

                        }

                    }

                }

            }

        },

        async goCheckout ( args: ISubscribeArgsWithDeviceInfo ): Promise<void> {

            if ( !this.planId ) {

                unfoldError( 'errors.no_plan_selected' );

            } else if ( !this.switchable && this.planId !== this.sub.plan.id ) {

                unfoldError( 'errors.frequent_switching' );

            } else {

                reolinkGa.sendECommerceEvent( 'select_item', this.gtagData );
                await this.$router.push({

                    path: '/checkout/',
                    query: {

                        p_id: this.planId.toString(),
                        ps_id: this.prev_sub_id,
                        selected_devices: args.selectedDevicesURL,
                        deviceOverflow: String( args.deviceOverflow ),
                        deviceGroupChange: String( args.deviceGroupChange ),
                        mode: this.planId.toString() === this.sub.plan.id ? ESubscribeMode.RENEW : ESubscribeMode.SWITCH

                    }

                });

            }

        },
        changeActive ( index ): void {

            this.activeItem = index;

        },
        calcPlanIsInWindow(): void {

            window.setTimeout(() => {

                let visible = isInVisibleArea( '#plans-select' );
                this.bottomButtonShow = !visible && this.initialized;

            }, 100 );

        },

    },
    computed: {

        message (): IPlanMessage[] {

            let { sub, refund } = this;
            let result: IPlanMessage[] = [
                {
                    label: this.$tc( 'update_plan.account_label' ),
                    texts: [
                        this.$store.state.user.user.email.address
                    ],
                },
                {
                    label: this.$tc( 'update_plan.plan_label' ),
                    texts: [
                        this.$options.filters!.planName( sub.plan )
                    ],
                }
            ];
            if ( refund && refund.length > 0 ) {

                let refundText = refund.map(( item ) => {

                    return `${item.currency} ${item.value}`;

                }).join( ' + ' );
                result.push({

                    label: this.$tc( 'update_plan.refund_label' ),
                    texts: [
                        refundText
                    ]

                });

            }
            return result;

        },
        title (): string {

            if ( this.sub ) {

                let planTitle = this.sub.plan.title;
                return this.$t( 'update_plan.title', {

                    plan: planTitle

                }) as string;

            }
            return '';

        },
        currentPlan (): number | string {

            let sub = this.sub;
            return sub.status === 'active' ? sub.plan.id : 0;

        },

        lang(): string  {

            return this.$store.getters.lang;

        },
        country(): string  {

            return this.$store.getters.country;

        },

        client (): string {

            return this.config.oem;

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

    }

});
</script>

<style scoped lang="less">
.update-plan{
    background-color: @bg_01;
    padding: 0.6rem 0;
    @media @mobile{
        background-color: @bg_01;
        padding: 0 20px;
        padding-bottom: 24px;
    }
    .planItemBox{
        @media @mobile{
            margin-top:.56rem;
        }

    }
    h1{
        font-weight: 600;
        font-size: 32px;
        margin-bottom: 4px;
        text-align: center;
        @media @mobile{
            font-size: 30px;
            font-weight: 500;
            margin-bottom: 24px;
        }
    }
    h3{
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 16px;
        @media @mobile{
            font-size: 16px;
            margin-bottom: 8px;
        }
        &.switch-title {
            margin-bottom: 0.16rem;
            @media @mobile{
                margin-bottom: 24px;
            }
        }
    }
    
    /deep/ .tabBox{
        margin-top: 24px;
        max-width: none;
        flex: 1;
        .mobile({
            margin-top: 12px;
        });
        .tabItem{
            flex: 1;
            &.show-discount{
                .mobile({
                    flex: 2;
                });
            }
        }
    }
    /deep/ .owl-carousel{
        .mobile({
            width: calc(100% - 76px);
        });
    }
}

.content{
    max-width: 1000px;
    margin: 0 auto;
    box-sizing: border-box;
    @media @mobile{
        padding: 20px 0;
        border-radius: @border-radius-level-button;
    }
    & > p{
        font-size: 16px;
        color: @font_secondary;
        text-align: center;
        margin-bottom: 32px;
    }
    .content-wrap{
        // max-width: 760px;
        margin: 0 auto;
        background-color: @bg_02;
        padding: 32px;
        border-radius: @border-radius-level-2;
        .mobile({
            padding: 16px;
        });
        & /deep/ .subscribePart{
            // margin: 0 1.8rem;
            @media @pc{
                .selectBox{
                    // margin-left: 1.8rem;
                    font-size: .16rem;
                    font-weight: 500;
                    line-height: 1.4;
                    margin-bottom: .12rem;
                    .selectText{
                        margin-bottom: .3rem;
                        display: block;
                    }
                    .loc-select{
                        margin-left: 0;
                    }
                }
                .countryBtn{
                    font-size:14px;
                    background: #fff;
                    font-weight: 500;
                    line-height: 1.4;
                    // margin-bottom: .32rem;
                    display: block;
                }
                .title{
                    font-size: .16rem;
                    line-height: 1.4;
                    font-weight: 500;
                    color:#333;
                    background: #fff;
                    margin-bottom: .12rem;
                }
                .notice-for-free{
                    padding:0;
                    line-height: 1.4;
                    text-align: left;
                    background: #fff;
                    margin-top: .12rem;
                    margin-bottom: .24rem;
                    .title{
                        font-weight: 400;
                        font-size: .16rem;
                    }
                }
                .tabBox{
                    margin-top: 0;
                    margin-bottom: 0.24rem;
                    border:none;
                    border-bottom:1px solid #ddd;
                    background-color: #fff;
                    justify-content: flex-start;
                    .tabItem{
                        margin-right: .12rem;
                    }
                    div{
                        border:1px solid @theme;
                        border-bottom:none;
                        flex:unset;
                        p{
                            font-size: .16rem;
                            padding:.1rem .2rem;
                        }
                    }
                    div:not(.active){
                        border:1px solid #ddd;
                        border-bottom:none;
                    }
                    p{
                        margin-bottom: 0;
                    }
                }
                .content-container{
                    padding:0;
                    background: #fff;
                    .content{
                        background-color: #fff;
                        padding:0;

                        .listTitle{
                            padding-bottom: .12rem;
                        }
                        .item-list{
                            border:none;
                            min-width: unset;
                            ul{
                                li.customer-item{
                                    width:25%;
                                }
                            }
                        }

                    }
                }

            }

            @media @mobile{
                .selectText{
                    padding-left: .3rem;
                }
                .selectBox{
                    background: #fff;
                    .selectText{
                        font-weight: 500;
                        padding-left: 0;
                    }
                }
                .countryBtn{
                    background: #fff;
                }
                .tabBox{
                    border:none;
                    border-bottom:1px solid #ddd;
                    padding:0 .3rem;
                    div{
                        border:1px solid @theme;
                        // border-bottom:none;
                    }
                    div:not(.active){
                        border:1px solid #ddd;
                        border-bottom:none;
                    }
                }
                .content-container{
                    margin-top: 0.3rem;
                    padding: 0 0.3rem 0;
                    .content{
                        .listTitle{
                            padding-bottom: .16rem;
                        }
                        .item-list{
                            border:none;
                            background: #f7f8f9;
                        }
                    }
                }

            }
        }
        .legacy_tip_container{
            font-size: .18rem;
            @media @pc{
                margin-bottom:.24rem;
                padding-top: .24rem;
            }
            @media @mobile{
                margin:.48rem .3rem .48rem;
                font-size: .26rem;
            }
            .legacy_tip{
                padding: 0.16rem 0.3rem;
                text-align: left;
                background: #FCF5EB;
                border-radius: 16px;
                display: flex;
                .icon-icon-hint-warning{
                    color:#C15400;
                    @media @pc{
                        font-size: .3rem;
                    }
                }
                .tip_content{
                    color:#333;
                    font-weight: 500;
                    margin-left:.2rem;
                    /deep/ .support-link{
                        font-weight: 500;
                        color:#333;
                        cursor: pointer;
                        text-decoration: underline;
                        text-decoration-thickness:1px;
                    }
                    /deep/ a{
                        font-weight: 500;
                    }
                }

            }
        }
        .planItemBox{
            margin-top: .3rem;
            @media @mobile{
                margin: .56rem .3rem 0;
            }
        }
        .note{
            margin: .16rem 0 .32rem;
            line-height: 1.4;
            font-size: .16rem;
            color:#333;
            p:nth-child(2){
                margin-top: .08rem;
            }
            p::before{
                content:'* ';
                color:#E74330;
            }
            @media @mobile{
                font-size: .26rem;
                margin: .3rem .3rem .48rem;
                p:nth-child(2){
                    margin-top: .16rem;
                }
            }
        }
    }
}

.plan-statement{
    padding-left: 0.4rem;
    position: relative;
    margin-bottom: 0.7rem;
    @media @mobile{
        padding-left: calc(22px + 0.2rem);
        margin: 0.44rem 0 0.88rem;
    }
}
.plan-statement-check{
    position: absolute;
    top: 0;
    left: 0;
}
.button-group{
    text-align: center;
    margin-top: .4rem;
    .ui-button+.ui-button{
        margin-left: 0.4rem;
    }
    @media @pc{
        .ui-button{
            box-sizing: border-box;
            width: 2rem;
            &.empty-button:hover{
                line-height: .5rem;
            }
        }
    }

    @media @mobile{
        margin: 0.6rem .3rem 0;
        .ui-button{
            width: 100%;
            box-sizing: border-box;
        }
        .ui-button+.ui-button{
            margin: 0.2rem 0 0;
        }
    }
}
/deep/ .reo-radio.checked{
    background-color: @theme !important;
}

.basic-plan{
    max-width: 12rem;
    margin:0rem auto .3rem;
    box-sizing: border-box;
    @media @mobile{
        padding-bottom: 0;
        padding:.36rem .3rem;
        background: #F7F8F9;
        margin-bottom:.96rem;
        margin-top:.3rem;
    }
}
.show-basic-plan-container{
        max-width: 12rem;
        text-align: left;
        margin: .22rem auto .22rem;
        line-break: 1.2;
        @media @mobile{
            margin-bottom: .22rem;
            padding:0 0.3rem;

        }

        .showBasicBtn{
            font-weight: 500;
            font-size: .16rem;
            @media @mobile{
                font-size:.28rem;
            }
            color:#333;
            cursor: pointer;
            span:last-child{
                transition: all .2s linear;
                margin-left: 8px;
            }

            &:hover{
                span:last-child{
                    margin-left: 16px;
                }
            }
        }
    }
</style>

<style lang="less">
.plan-statement a{
    color: @theme;
    font-weight: 500;
}
.plan-statement a:hover{
    text-decoration: underline;
}
.update-plan h3 span{
    font-weight: 400;
    font-size: 0.16rem;
    @media @mobile{
        font-size: 0.24rem;
    }
}
.update-plan .notice-for-free{
    margin: 0 0 .22rem;
    font-size: .16rem;
    font-weight: 500;
    color: #E74330;
    .title,
    .des{
        font-size: 0.16rem;
    }
    @media @mobile{
        font-size: 0.26rem;
        margin: .2rem 0 .25rem;
        .title,
        .des{
            font-size: 0.26rem;
        }
    }
}
.reo-dialog.selectProduct{
    /deep/ .reo-dialog-inner{
        max-width: unset;
    }
}
</style>

<style lang="less" scoped>
    .button-outer-container{
        gap: 20px;
        display: flex;
        justify-content: center;
        @media @snapeak_mobile{
            flex-direction: column;
            gap: 10px;
            padding: 0 15px;
        }
        .button-outer-container();
    }
    .bottom-button-container{
        gap: 20px;
        display: flex;
        justify-content: center;
        @media @snapeak_mobile{
            flex-direction: column;
            gap: 10px;
        }
        .bottom-button-container();
    }

    .attention{
        max-width: 974px;
        box-sizing: border-box;
    }

    /deep/ .plan-item{
        border:1px solid #ddd
    }
    
    .plans{
        background-color: @bg_02;
        border-radius: @border-radius-level-2;
        padding: 32px;
        margin-top: 24px;
        .mobile({
            padding: 16px;
            margin-top: 20px;
        });
        h3{
            margin-bottom: 0;
        }
    }
</style>
